<template>
    <div class="types-update-modal">
        <ModalContainer :title="$t('types.edit_type')" identifier="types-update-modal" :closable="true">
            <Form class="form" @submit="save" :disabled="is_loading_original || is_loading_categories || is_saving">
                <FormInputText v-model="$v.type.name.$model" identifier="name" :label="$t('types.name')"
                               :disabled="is_loading_original || is_loading_categories || is_saving" :has-error="$v.type.name.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.type.name.required">
                            {{$t('validation.x_is_required',{x: $t('types.name')})}}
                        </p>
                    </template>
                </FormInputText>

                <FormInputSelect v-model="$v.type.category.$model" identifier="role"
                                 :label="$t('types.category')" :options="categoryOptions"
                                 :disabled="is_loading_original || is_loading_categories || is_saving" :has-error="$v.type.category.$error" track-by="id"
                                 :display-custom-label="(row) => `${row.attributes.name}`">
                    <template v-slot:errors>
                        <p v-if="!$v.type.category.required">
                            {{$t('validation.x_is_required',{x: $t('types.category')})}}
                        </p>
                    </template>
                </FormInputSelect>

                <Button type="submit" className="--primary --small" :class="{spinner: is_saving}">
                    {{$t('save')}}
                </Button>
            </Form>
        </ModalContainer>
    </div>
</template>

<script>
    import _ from 'lodash';
    import ModalContainer from "../modal/ModalContainer";
    import Form from "../form/Form";
    import FormInputText from "../form/FormInputText";
    import FormGroupTwo from "../form/FormGroupTwo";
    import FormInputSelect from "../form/FormInputSelect";
    import {required, email} from 'vuelidate/lib/validators'
    import Button from "../Button";
    import FormInputPassword from "@/components/form/FormInputPassword";

    export default {
        name: "TypesUpdateModal",
        components: {FormInputPassword, Button, FormInputSelect, FormGroupTwo, FormInputText, Form, ModalContainer},
        props: {
            type_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                original: null,
                type: {
                    name: null,
                    category: null,
                },
                categoryOptions: [],
                is_saving: false,
                is_loading_original: false,
                is_loading_categories: false,
            }
        },
        validations: {
            type: {
                name: {required},
                category: {required},
            }
        },
        methods: {
            close(status) {
                this.$modal.hide('types-update-modal', status);
            },
            save() {
                this.$v.type.$touch();
                if (this.$v.type.$anyError || this.is_saving)
                    return;

                this.is_saving = true;

                const payload = {
                    name: this.type.name,
                    category_id: this.type.category.id
                }

                this.$axios.patch(`types/${this.type_id}`, payload).then(({data}) => {
                    this.$notify({
                        text: this.$t('types.success_updated'),
                        type: 'success',
                    });

                    this.is_saving = false;
                    this.close(true);
                }).catch(e => {
                    this.is_saving = false;

                    this.$notify({
                        title: this.$t('error'),
                        text: this.$larerror(e.response.data.errors, this.$t('types.error_update')),
                        type: 'error',
                    });
                });
            },
            populate() {
                if (!this.original || !this.type)
                    return;

                this.$v.type.name.$model = this.original.attributes.name;
                this.$v.type.category.$model = _.find(this.categoryOptions, {id: this.original.relationships.category.data.id});
            },
            async retrieveOriginalType() {
                this.is_loading_original = true;

                await this.$axios.get(`types/${this.type_id}`)
                    .then(({data}) => {
                        this.original = data.data;
                        this.is_loading_original = false;
                    })
                    .catch(e => {
                        this.is_loading_original = false;

                        this.$notify({
                            title: this.$t('error'),
                            text: this.$larerror(e.response.data, this.$t('types.error_retrieve')),
                            type: 'error',
                        });
                    });
            },
            async retrieveCategoryOptions() {
                this.is_loading_categories = true;

                await this.$axios.get('categories/list')
                    .then(({data}) => {
                        this.categoryOptions = data.data;
                        this.is_loading_categories = false;
                    })
                    .catch(e => {
                        this.is_loading_categories = false;

                        this.$notify({
                            title: this.$t('error'),
                            text: this.$larerror(e.response.data, this.$t('categories.error_retrieve')),
                            type: 'error',
                        });
                    });
            }
        },
        async mounted() {
            await this.retrieveOriginalType();
            await this.retrieveCategoryOptions();
            this.populate();
        }
    }
</script>
